<!--
 * @Description: 拣货表
 * @version: 1
 * @Author: lk
 * @Date: 2019-08-23 15:22:50
 -->
<template>
  <el-dialog v-loading.fullscreen="loading" title="拣货表打印" :visible="visible" width="50%" :show-close="true"
    :close-on-press-escape="false" :close-on-click-modal="false" center @close="$emit('close')">
    <div style="display: flex; justify-content: space-between;align-items: self-start;">
      <el-form inline>
        <el-form-item label="打印机选择">
          <el-select v-model="printInfo.printIndex" width="100%">
            <el-option v-for="item in printers" :key="item.index" :label="item.name" :value="item.index" />
          </el-select>
        </el-form-item>
      </el-form>
      <el-button v-if="$btnsPermission('picking:print')" @click="handlePrint">
        <i class="el-icon-printer"></i>打印
      </el-button>
    </div>
    <div id="printweb">
      <div v-for="(item, index) in pickingList" :key="index" style="margin-bottom: 12px;">
        <div :id="`table${index}`" style="width: 100%;">
          <table style="border-color:black;width: 100%;text-align: center;" border="1" cellpadding="8" cellspacing="0">
            <thead>
              <tr style="text-align: center;">
                <th colspan="7" style="height: 15mm;"> 拣货单</th>
                <th style="display: none;"></th>
                <th style="display: none;"></th>
                <th style="display: none;"></th>
                <th style="display: none;"></th>
                <th style="display: none;"></th>
                <th style="display: none;"></th>
                <th style="display: none;"></th>
              </tr>
              <tr>
                <th colspan="7">
                  <div style="display: flex;padding: 12px 0 0px;">
                    <div style="width: 24mm;height: 18mm;position: relative;">
                      <img :id="`img${index}`" style="width: 18mm;height: 18mm;;position: absolute;left: 0;top:-1mm"
                        :src="item.qrCode" />
                    </div>

                    <div style="min-height: 18mm;text-align: left;flex: 1;">
                      <div style="display: flex;">
                        <div style="text-align: right;width: 22mm;">单据编号：</div>{{ item.bizId }}
                      </div>
                      <div style="display: flex;margin: 1mm 0;">
                        <div style="display: flex;width: 60mm;">
                          <div style="text-align: right;width: 22mm;"> 客户：</div>
                          <div> {{ item.recipientInfoVo ? item.recipientInfoVo.customer : null }} </div>
                        </div>
                        <div style="display: flex;flex: 1;">
                          <div style="width: 32mm;text-align: right"> 指定发货日期：</div>
                          <div>{{ item.specifyDeliveryDate }} </div>
                        </div>
                      </div>
                      <div style="display: flex;">
                        <div style="display: flex;width: 60mm;">
                          <div style="text-align: right;width: 22mm;"> 销售部门：</div>
                          <div> {{ item.applyOrgName }} </div>
                        </div>
                        <div style="display: flex;flex: 1;">
                          <div style="width: 28mm;text-align: right"> 收件地址：</div>
                          <div>{{ item.recipientInfoVo | formateArea }} </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </th>
                <th style="display: none;">商品</th>
                <th style="display: none;">商品</th>
                <th style="display: none;">商品</th>
                <th style="display: none;">商品</th>
                <th style="display: none;">商品</th>
                <th style="display: none;">商品</th>
              </tr>
              <tr>
                <th style="padding: 1mm;">编号</th>
                <th style="padding: 1mm;">物料编号</th>
                <th style="padding: 1mm;">物料名称</th>
                <th style="padding: 1mm;">DI码</th>
                <th style="padding: 1mm;">规格型号</th>
                <th style="padding: 1mm;">批号</th>
                <th style="padding: 1mm;">数量</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(info, i) in item.goodsVoList" :key="info.ogoodsId" :class="info.isParent === 'Y' ? 'gray' : ''">
                <td style="padding: 2mm;">{{ i + 1 }}</td>
                <td style="padding: 2mm;">{{ info.goodsCode }}</td>
                <td style="padding: 2mm;">{{ info.goodsName }}</td>
                <td style="padding: 2mm;">{{ info.diCode }}</td>
                <td style="padding: 2mm;">{{ info.specification }}</td>
                <td style="padding: 2mm;">{{ info.batchNumber }}</td>
                <td style="padding: 2mm;">{{ info.packageNumber }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="9" style="padding: 2mm;text-align: right;font-size: 14px;">
                  包装数量合计：{{ item.packageCount }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getPrintPickingOrder, updatePrintStatus } from "@/api/orderManage";
import QRCode from "qrcode";
import { getLodop } from "@/components/print/LodopFuncs";
export default {
  name: "PrintPicking",
  filters: {
    formateArea(value) {
      if (value) {
        const {
          consigneeProvinceName = "",
          consigneeCityName = "",
          consigneeCountyName = "",
          customerAddress = ""
        } = value;
        return `${consigneeProvinceName}${consigneeCityName}${consigneeCountyName}${customerAddress}`;
      }
      return null;
    }
  },
  props: {
    orderIds: {
      type: Array,
      default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      jobCode: '',//job码
      printStatus: '0',//打印状态
      number: 0, // 循环次数
      printInfo: {
        printIndex: 4,
        printNum: 1
      },
      printers: [],
      loading: false,
      pickingList: []
    };
  },
  created() {
    setTimeout(() => {
      this.getList();
    }, 1000);
    this.getPrintInfo();
  },
  methods: {
    // 获取打印机列表
    getList() {
      const LODOP = getLodop();
      if (!LODOP) return;
      // 获取所有打印机
      let printerNum = LODOP.GET_PRINTER_COUNT();
      let printerList = [];
      for (let index = 0; index < printerNum; index++) {
        printerList.push({ index, name: LODOP.GET_PRINTER_NAME(index) });
      }
      this.printers = printerList;
      // 获取默认打印机
      let printer = localStorage.getItem(`printer:${this.printerType}`);
      if (printer) {
        this.defaultPrinter = parseInt(printer);
      }
    },
    getPrintInfo() {
      this.pickingList = [];
      this.loading = true;
      getPrintPickingOrder(this.orderIds.join(","))
        .then((res) => {
          if (res.code === "400") {
            this.$message({
              type: "error",
              message: res.msg
            });
          } else {
            this.pickingList = res.data.map((item) => {
              return {
                ...item,
                packageCount: item.goodsVoList.reduce(
                  (a, b) => a + b.packageNumber,
                  0
                )
              };
            });
            res.data.forEach((item, index) => {
              QRCode.toDataURL(item.orderId)
                .then((url) => {
                  this.$set(this.pickingList[index], "qrCode", url);
                })
                .catch((err) => {
                  console.error(err);
                });
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 处理打印
    handlePrint() {
      const LODOP = getLodop();
      const that = this;
      if (!LODOP) return;
      this.pickingList.forEach((item, index) => {
        LODOP.PRINT_INIT("打印出货单");
        // LODOP.SET_PRINT_PAGESIZE(2, '210mm', '297mm', '')
        // let strBodyStyle =
        //   "<style>table,td { border: 1 solid black;border-collapse:collapse }</style>";
        // const imgele = document.getElementById(`img${index}`)
        // imgele.style.top = '-1000px'
        // const table =
        //   strBodyStyle +
        //   "<body>" +
        //   document.getElementById(`table${index}`).innerHTML +
        //   "</body>";
        // LODOP.ADD_PRINT_HTM('45mm', 0, "240mm", "267mm", table);
        // LODOP.SET_PRINT_STYLEA(0, "HOrient", 2);
        // LODOP.ADD_PRINT_BARCODE('24mm', '2mm', '20mm', '20mm', 'QRCode', item.orderId)
        // LODOP.SET_PRINT_STYLEA(0, 'AlignJustify', 2)
        // LODOP.SET_PRINT_STYLEA(0, 'Bold', 0)
        // LODOP.SET_PRINT_STYLEA(0, 'FontSize', 3)
        // LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1)
        // LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', 1)
        // const content = document.getElementById(`print${index}`).innerHTML
        // LODOP.ADD_PRINT_HTM('10mm', 0, "240mm", "267mm", content);
        // LODOP.SET_PRINT_STYLEA(0, "HOrient", 2);
        LODOP.SET_PRINT_PAGESIZE(2, 0, 0, "A4");
        LODOP.ADD_PRINT_TABLE("2%", "1%", "96%", "98%", document.getElementById(`table${index}`).innerHTML);
        LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS", true);
        if (LODOP.SET_PRINTER_INDEXA(this.printInfo.printIndex)) {
          LODOP.On_Return = function (TaskID, Value) {
            that.jobCode = Value
            setTimeout(() => {
              var timer = setInterval(function () {
                if (that.printStatus == '1') {
                  clearInterval(timer);
                  updatePrintStatus({ orderIdList: that.orderIds })
                  that.printStatus = '0'
                  that.jobCode = null
                  return;
                }
                if (that.number === 25) {
                  clearInterval(timer);
                  that.printStatus = '0'
                  that.jobCode = null
                }
                that.number++
                that.getStatusValue(LODOP);
              }, 1000);
            }, 1000)
          };
          LODOP.PRINT();
          // imgele.style.top = '-2mm'
        }
      });
      this.$message.success('打印命令已发送，请稍后查看')
      this.$emit('close')
    },
    getStatusValue(LODOP) {//根据job代码，获取是否打印成功
      const self = this
      LODOP.On_Return = function (TaskID, Value) {
        console.log("TaskID:" + TaskID);
        console.log("打印成功状态:" + Value, typeof Value);//打印成功状态
        self.printStatus = Value
      };
      LODOP.GET_VALUE("PRINT_STATUS_OK", this.jobCode);

    },

  }
};
</script>
<style></style>
